import dbaStep1Desktop from './DBA-step1-desktop';
import dbaStep2Desktop from './DBA-step2-desktop';
import dbaStep3Desktop from './DBA-step3-desktop';
import dbaStep1Mobile from './DBA-step1-mobile';
import dbaStep2Mobile from './DBA-step2-mobile';
import dbaStep3Mobile from './DBA-step3-mobile';

import finnStep1Desktop from './FINN-step1-desktop';
import finnStep2Desktop from './FINN-step2-desktop';
import finnStep3Desktop from './FINN-step3-desktop';
import finnStep1Mobile from './FINN-step1-mobile';
import finnStep2Mobile from './FINN-step2-mobile';
import finnStep3Mobile from './FINN-step3-mobile';

import toriStep1Desktop from './Tori-step1-desktop';
import toriStep2Desktop from './Tori-step2-desktop';
import toriStep3Desktop from './Tori-step3-desktop';
import toriStep1Mobile from './Tori-step1-mobile';
import toriStep2Mobile from './Tori-step2-mobile';
import toriStep3Mobile from './Tori-step3-mobile';

const illustrationMap: Record<string, Record<number, { desktop: Function; mobile: Function }>> = {
    dba: {
        1: { desktop: dbaStep1Desktop, mobile: dbaStep1Mobile },
        2: { desktop: dbaStep2Desktop, mobile: dbaStep2Mobile },
        3: { desktop: dbaStep3Desktop, mobile: dbaStep3Mobile },
    },
    finn: {
        1: { desktop: finnStep1Desktop, mobile: finnStep1Mobile },
        2: { desktop: finnStep2Desktop, mobile: finnStep2Mobile },
        3: { desktop: finnStep3Desktop, mobile: finnStep3Mobile },
    },
    tori: {
        1: { desktop: toriStep1Desktop, mobile: toriStep1Mobile },
        2: { desktop: toriStep2Desktop, mobile: toriStep2Mobile },
        3: { desktop: toriStep3Desktop, mobile: toriStep3Mobile },
    },
};

// Tablet and desktop will give wider versions of illustrations,
// while mobile will give more narrow versions.
const getDevice = (device: string): 'desktop' | 'mobile' => {
    if (device === 'mobile') return device;
    return 'desktop';
};

export const getStepIllustration = (
    step: number,
    brand: string | undefined,
    device: string,
    altText: string,
) => {
    const brandIllustrations = illustrationMap[brand || ''];
    if (!brandIllustrations) {
        console.error(`TJT: Could not find onboarding illustrations for this brand: ${brand}`);
        return null;
    }

    const deviceType = getDevice(device);
    const illustration = brandIllustrations[step][deviceType];

    if (!illustration) {
        console.error(
            `TJT: Could not find onboarding illustration at step ${step} with this deviceType: ${device}`,
        );
        return null;
    }

    return illustration(altText);
};
